// extracted by mini-css-extract-plugin
module.exports = {"marginTop":"AuditPage_marginTop__3dEgv","marginBottom":"AuditPage_marginBottom__2UooL","advancedAuditTable":"AuditPage_advancedAuditTable__nazwB"};